import AscPageErrorContainer from './containers/AscPageErrorContainer'

const pageErrorRouter = [
  {
    path: '/404',
    name: 'PageNotFound',
    display: false,
    component: AscPageErrorContainer,
    meta: {
      primaryNavigation: false,
      breadcrumbs: [],
    },
    props: {
      errorType: 404,
    },
  },
]

export default pageErrorRouter
